const tabsUser = {
  active: 'ATIVOS',
  invite: 'CONVITES',
  Typography: 'Nenhum resultado encontrado'
};

export default tabsUser;
